<template>
  <div class="signFor">
    <el-dialog
      title="签收数量登记"
      :visible.sync="signForVisible"
      width="60%"
      :before-close="handleClose">
      <el-table
        :data="signForInfo"
        style="width: 100%">
          <el-table-column type="index"
                           fixed
                           align="center"
                           min-width="60"
                           label="序号"
                           key="index">
          </el-table-column>
          <el-table-column prop="name"
                           label="商品名称"
                           min-width="150">
          </el-table-column>
          <el-table-column prop="deliveryNum"
                           label="配送数量"
                           align="center"
                           min-width="120">
                <template slot-scope="scope">
                  <div>{{scope.row.deliveryNum}}{{ scope.row.minUnitName }}</div>
                  <div style="color: #808080">
                    <label>({{parseInt(scope.row.deliveryNum/scope.row.box)}}{{scope.row.maxUnitName}}</label>
                    <label>{{scope.row.deliveryNum%scope.row.box}}{{scope.row.minUnitName}})</label>
                  </div>
              </template>
          </el-table-column>
          <el-table-column label="平台实收"
                           align="center"
                           min-width="120">
                <template slot-scope="scope">
                  <div>{{scope.row.deliveryNum-toNumber(scope.row.rejectionNum)-toNumber(scope.row.discardNum)}}{{ scope.row.minUnitName }}</div>
                  <div style="color: #808080">
                    <label>({{parseInt((scope.row.deliveryNum-toNumber(scope.row.rejectionNum)-toNumber(scope.row.discardNum))/scope.row.box)}}{{scope.row.maxUnitName}}</label>
                    <label>{{(scope.row.deliveryNum-toNumber(scope.row.rejectionNum)-toNumber(scope.row.discardNum))%scope.row.box}}{{scope.row.minUnitName}})</label>
                  </div>
                </template>
          </el-table-column>
          <el-table-column prop="rejectionNum"
                           label="拒收数量"
                           min-width="150">
                <template slot-scope="scope">
                  <el-input-number :controls="false" v-model="scope.row.rejectionNum" :min="0" style="width:120px" :step="1" step-strictly @blur="changeNum($event)"></el-input-number>{{ scope.row.minUnitName }}
                </template>
          </el-table-column>
          <el-table-column prop="discardNum"
                           label="破损废弃"
                           min-width="150">
                <template slot-scope="scope">
                  <el-input-number :controls="false" v-model="scope.row.discardNum" :min="0" style="width:120px" :step="1" step-strictly @blur="changeNum($event)"></el-input-number>{{ scope.row.minUnitName }}
                </template>
          </el-table-column>
          <el-table-column prop="barCode"
                           label="商品条码"
                           min-width="120">
          </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <div style="text-align:left;color:grey">提示：平台实收数量=配送数量-拒收数量-破损废弃数量；拒收数量将自动生成拒收入库任务。</div>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// SUBMITTASKSIGNREGISTER
import { SUBMITTASKSIGNREGISTER } from '@/store/assignmentManage/types.js'

export default {
  props: ['signForInfo', 'signForVisible', 'code'],
  data () {
    return {

    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog', false)
    },
    submit () {
      let signRegisterList = []
      for (let i = 0; i < this.signForInfo.length; i++) {
        if (this.signForInfo[i].rejectionNum + this.signForInfo[i].discardNum > this.signForInfo[i].deliveryNum) {
          this.$message({
            showClose: true,
            message: '拒收数量+破损废弃数量需<=配送数量',
            type: 'error'
          })
          return
        } else {
          signRegisterList.push({
            id: this.signForInfo[i].id,
            goodsCode: this.signForInfo[i].goodsCode,
            rejectionNum: this.signForInfo[i].rejectionNum || 0, // 拒收数量
            discardNum: this.signForInfo[i].discardNum || 0 // 破损废弃数量
          })
        }
      }
      let params = {
        code: this.code,
        signRegisterList
      }
      this.$store.dispatch(SUBMITTASKSIGNREGISTER, JSON.stringify(params)).then(res => {
        if (res.code === 200) {
          this.$message({
            showClose: true,
            message: res.obj,
            type: 'success'
          })
        } else {
          this.$message({
            showClose: true,
            message: '任务状态异常，请稍后重试',
            type: 'error'
          })
        }
        this.$emit('closeDialog', true)
      })
    },
    changeNum (e) {
      if (e.target.value === '') {
        e.target.value = 0
      }
    },
    toNumber (num) {
      if (!num) {
        return 0
      } else {
        return num
      }
    }
  }
}
</script>
<style>
.signFor .el-dialog__header{
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/components/signFor.vue